/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CoBuyDetailPage = lazyLoad(
  () => import('./index'),
  module => module.CoBuyDetailPage
);
